module.exports = new __parcel__URL__("clock.1b41be8a.svg").toString();